import { Injectable } from "@angular/core";
import { KpiBaseChartDto, KpiChartDisplayType, KpiChartType } from "../../../services";

@Injectable({
  providedIn: "root",
})
export class ChartUtilService {
  private palette: string[] = [
    "#000e52",
    "#00ff64",
    "#4affff",
    "#225494",
    "#42659f",
    "#8da5c4",
    "#00766e",
    "#009a7c",
    "#009a7c",
    "#efec00",
    "#ff1b7c",
  ];

  constructor() {}

  isTimeBasedChart(chartType: KpiChartType): boolean {
    return (
      chartType === KpiChartType.ProcessingTime ||
      chartType === KpiChartType.ProcessingTimeSuccessful ||
      chartType === KpiChartType.ProcessingTimeUnsuccessful
    );
  }

  isStaticChart(chart: KpiBaseChartDto): boolean {
    return (
      chart?.chartType === KpiChartType.NumberOfMyServicesUsersSummary ||
      chart?.chartType === KpiChartType.NumberOfMyServicesUsersGrowth
    );
  }

  isNumberChart(chart: KpiBaseChartDto): boolean {
    return chart?.displayType === KpiChartDisplayType.number;
  }

  showColorPicker(displayType: KpiChartDisplayType): boolean {
    return displayType === KpiChartDisplayType.bar || displayType === KpiChartDisplayType.line;
  }

  getPaletteColors(): string[] {
    return this.palette;
  }

  getDefaultColor(): string {
    return this.palette[0];
  }
}
